import {put, select} from 'redux-saga/effects';
import {TalkViewerState} from '../state/TalkViewerState.interface';
import {playMedia, registerBgm, showFullscreen} from '../state/talkViewerSlice';
import {TalkKey} from '../type/KeyType.type';
import {TalkDataType} from '../type/TalkDataType.enum';
import {VideoPlayType} from '../type/VIdeoPlayType.enum';
import {selectTalkViewerState} from './selector';

/**
 * 미디어, 풀스크린 이미지 등 톡에 담겨 있는 이벤트를 실행시킨다.
 * @param talkId 실행 시킬 톡 아이디
 * @param isAuto 유저가 톡에 직접적인 액션을 가하지 않았는데 이벤트가 발생하는 지 여부 (탭모드에서의 톡 진행, 탭모드에서 특정 톡 이동 등)
 */
export function* talkEventFired(talkId: TalkKey, isAuto: boolean) {
  const talkViewerState: TalkViewerState = yield select(selectTalkViewerState);
  const talk = talkViewerState.talkMap[talkId];
  if (!talk) {
    return;
  }
  // 풀스크린 이미지는 미디어 오토플레이 여부와는 상관 없이 항상 풀스크린을 띄워준다
  if (talk.datatype === TalkDataType.FullscreenImage) {
    yield put(showFullscreen({isAuto, talkId}));
    return;
  }
  if (talkViewerState.settings.mediaAutoPlay) {
    switch (talk.datatype) {
      case TalkDataType.FullscreenVideo: {
        yield put(showFullscreen({isAuto, talkId}));
        yield put(playMedia(talkId));
        break;
      }
      case TalkDataType.Bgm:
      case TalkDataType.Sound:
      case TalkDataType.TalkEffect: {
        yield put(playMedia(talkId));
        break;
      }
      case TalkDataType.Movie: {
        // videoPlayType이 App인 경우, 인라인 동영상도 모두 풀스크린 동영상으로 해소할 수 있도록 해 준다.
        if (talkViewerState.videoPlayType === VideoPlayType.App) {
          yield put(showFullscreen({isAuto, talkId}));
        }
        yield put(playMedia(talkId));
        break;
      }
    }
  } else {
    if (talk.datatype === TalkDataType.Bgm) {
      // 자동재생이 아닌 경우는 배경음 등록만 한다
      yield put(registerBgm(talkId));
    }
  }
}
